import normalizeEntity from './entity-normalizer';

export default normalizeEntity;
